<template>
  <div class="view-page"
       v-bind:class="{ 'page-full-screen': getStyle() }">
    <header class="header">
      <marquee-text
        :duration="duration"
        :repeat="repeat">
        <h2 class="header-title mb-0">
          <span class="text-danger text-uppercase mx-3"
                v-html="page.title.rendered"></span>
          <span v-html="page.fields.page_marquee"></span>
        </h2>
      </marquee-text>
    </header>
    <div class="content"
         v-bind:style="getStyle()">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-10">
            <div class="row">
              <div class="col">
                <span v-html="page.content.rendered"></span>
              </div>
              <div class="col-md-6"
                   v-if="page.featured">
                <div class="item-image"
                     v-bind:class="{ active : active }"
                     v-on:click="toggleItem()">
                  <img class="img-fluid"
                       v-bind:src="page.featured.sizes.large" />
                  <div class="klavika-container"
                       v-on:mouseenter="active = !active"
                       v-on:mouseleave="active = !active">
                    <span class="klavika">D</span>
                  </div>
                  <div class="item-content">
                    <ul class="list-unstyled">
                      <li class="list-item title"
                          v-html="page.featured.title.rendered"
                          v-if="page.featured.title.rendered"></li>
                      <li class="list-item title"
                          v-html="page.featured.title"
                          v-else></li>
                      <li class="list-item caption"
                          v-if="page.featured.caption">{{ page.featured.caption }}</li>
                      <li class="list-item description"
                          v-if="page.featured.description">{{ page.featured.description }}</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <site-footer />
  </div>
</template>

<script>
export default {
  name: 'view-page',
  data () {
    return {
      duration: 30,
      page: false,
      repeat: 2,
      active: 0
    }
  },
  beforeMount () {
    this.getPage()
  },
  watch: {
    '$route.params.slug': function () {
      this.getPage()
    }
  },
  methods: {
    getPage () {
      this.page = this.$store.getters.getItemBySlug('page', this.$route.params.slug)
    },
    getStyle () {
      if (this.page.fields.fullscreen_featured_image && this.page.featured.sizes.large) {
        return {
          backgroundImage: 'url(' + this.page.featured.sizes.large + ')'
        }
      }
      return false
    },
    stripTags (html) {
      return html.replace(/(<([^>]+)>)/ig, '')
    },
    toggleItem () {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.active = !this.active
      }
    }
  }
}
</script>
